<template>
  <v-autocomplete
    v-model="tags"
    label="カテゴリ・タグ"
    :items="selectableTags"
    :loading="isLoading"
    :search-input.sync="searchQuery.name_cont"
    item-text="name"
    item-value="id"
    cache-items
    hide-selected
    multiple
    return-object
  >
    <template v-slot:no-data>
      <v-list-item v-if="!searchQuery.name_cont">検索してください</v-list-item>
      <v-list-item v-else-if="isLoading">
        <v-list-item-title class="text-center">
          <v-progress-circular
            indeterminate
            color="blue-grey"
          ></v-progress-circular>
        </v-list-item-title>
      </v-list-item>
      <v-list-item v-else>
        <v-list-item-title> 見つかりませんでした </v-list-item-title>
      </v-list-item>
    </template>
    <template v-slot:selection="{ attrs, item, parent }">
      <v-chip
        v-if="item === Object(item)"
        v-bind="attrs"
        :input-value="item.id"
        label
        small
        outlined
        class="mx-1 my-1"
      >
        <v-tooltip>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" class="pr-2" v-on="on">
              {{ item.name }}
            </span>
          </template>
        </v-tooltip>
        <v-icon small @click="parent.selectItem(item)">mdi-close</v-icon>
      </v-chip>
    </template>
    <template v-slot:item="{ item }">
      <template>
        <v-list-item-content>
          <v-list-item-title v-html="`${item.name}`" />
        </v-list-item-content>
      </template>
    </template>
  </v-autocomplete>
</template>

<script>
import axios from 'axios'
import Qs from 'qs'
import { deserialize } from 'deserialize-json-api'
import _ from 'lodash'

export default {
  name: 'SelectableTags',
  props: {
    value: {
      object: Array,
      require: true
    },
    label: {
      object: String,
      require: false,
      default: ''
    },
    siteKey: {
      object: String,
      require: true
    }
  },
  data: function () {
    return {
      tags: this.value,
      searchQuery: {
        name_cont: ''
      },
      selectableTags: this.value,
      isLoading: false,
      debounceFetch: null
    }
  },
  watch: {
    'searchQuery.name_cont': function (val) {
      if (!val) {
        this.isLoading = false
        return
      }
      this.isLoading = true
      this.debounceFetch()
    },
    tags: function () {
      this.$emit('input', this.tags)
    }
  },
  mounted () {
    this.debounceFetch = _.debounce(this.fetchSelectableTags, 500)
  },
  methods: {
    fetchSelectableTags () {
      if (
        !this.searchQuery.name_cont ||
        this.searchQuery.name_cont.length === 0
      ) { return }
      axios
        .get('/api/master/tags', {
          params: { site_key: this.siteKey, q: this.searchQuery },
          paramsSerializer: function (params) {
            return Qs.stringify(params, { arrayFormat: 'brackets' })
          }
        })
        .then(({ data }) => {
          this.selectableTags = deserialize(data).data
        })
        .finally(() => (this.isLoading = false))
    }
  }
}
</script>
